module.exports = __webpack_public_path__ + "static/media/video-1.7e0c30b1.mp4";